











//@ts-ignore
  import { Vue2TinymceEditor } from "vue2-tinymce-editor";
import { Vue, Component, Prop, Watch } from "../../Infrastructure/CorBase/CoreBase";



@Component({
    components: {
        Vue2TinymceEditor
    }
})  
export default class BaseTLhtmlEditor extends Vue {
    @Prop({ type: String, required: false, default: "" }) content?: string; //hlavní popis


   
    options = {
        menubar: true,
        plugins: 'table lists advlist autolink charmap code codesample directionality emoticons paste_data_images searchreplace visualblocks code fullscreen insertdatetime media  paste code help   image  object_resizing Tools print preview anchor',
        toolbar1: 'undo redo |fontselect | fontsizeselect | formatselect |  italic underline strikethrough forecolor backcolor | image ',
        toolbar2: 'alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | link table removeformat code ',
        toolbar3: 'table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
        paste_data_images: true,
        object_resizing: true,
        imageDrop: true,
        resize: true,
        height: 701,
        editimage: true,
        skin: true,
        inline: false,
        fontsize_formats: '8px 10px 12px 14px 18px 20px 22px 24px 26px 28px 30px 32px 34px 36px',
        automatic_uploads: false,
     /*   images_upload_handler: false,*/
        content_css: '../../src/BaseRedesign/scss/all_in_one_style_file.scss'
    }

    optionsPUVODNI = {
        menubar: true,
        plugins: 'lists advlist autolink charmap code codesample directionality emoticons paste_data_images searchreplace visualblocks code fullscreen insertdatetime media  paste code help   image  object_resizing Tools print preview anchor',
        toolbar1: 'undo redo |fontselect | fontsizeselect | formatselect |  italic underline strikethrough forecolor backcolor | image ',
        toolbar2: 'alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | link table removeformat code |  numlist bullist',
        paste_data_images: true,
        object_resizing: true,
        imageDrop: true,
        resize: true,            
        height:700,
        editimage: true,
        skin: true,
        inline: false,
        automatic_uploads: true,
        images_upload_handler: true,
        content_css: '../../src/BaseRedesign/scss/all_in_one_style_file.scss'
    }

    options2 = {
        menubar: true,
        plugins: ' advlist autolink charmap code codesample directionality emoticons paste_data_images searchreplace visualblocks table code fullscreen insertdatetime media  paste code help   image  object_resizing Tools print preview anchor',
        toolbar1: 'undo redo |fontselect | fontsizeselect | formatselect |  italic underline strikethrough forecolor backcolor',
        toolbar2: 'alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | link table removeformat code | image',
        paste_data_images: true,
        object_resizing: true,
        editimage: true,
        skin: false,
        automatic_uploads: true,
        images_upload_handler: true
    }

    @Watch('content')
    onPropertyUrl(value: any, oldValue: any) {
        if (value !== oldValue) {
            this.$emit("content", this.content);
        }
    }

}
